import { ReactNode, createContext, useContext } from 'react';
import getConfig from 'next/config';
import { IterableEmbeddedProvider, useOnJwtRequest } from '@care/iterable-display';
import useTestFlags from '@/components/hooks/useTestFlags';

const {
  publicRuntimeConfig: {
    ITERABLE_MFE_API_KEY,
    ITERABLE_MFE_PACKAGE_NAME,
    ITERABLE_MFE_GUEST_USER_ID,
    ITERABLE_TOP_BANNER_PLACEMENT_ID,
  },
} = getConfig();

const IterablePlacementContext = createContext<number | undefined>(undefined);

export const useIterablePlacementId = () => {
  const context = useContext(IterablePlacementContext);
  if (context === undefined) {
    throw new Error('useIterablePlacementId must be used within <IterableWrapper>');
  }
  return context;
};

type IterableWrapperProps = {
  children: ReactNode;
};

export const IterableWrapper = ({ children }: IterableWrapperProps) => {
  const { iterableEmbeddedMessaging } = useTestFlags();

  const getJWTRequest = useOnJwtRequest(ITERABLE_MFE_GUEST_USER_ID);

  const resolvedPlacementId = Number(ITERABLE_TOP_BANNER_PLACEMENT_ID);

  return (
    <IterableEmbeddedProvider
      userId={ITERABLE_MFE_GUEST_USER_ID}
      packageName={ITERABLE_MFE_PACKAGE_NAME}
      apiKey={ITERABLE_MFE_API_KEY}
      placementIds={[resolvedPlacementId]}
      onJwtRequest={getJWTRequest}
      disabled={!iterableEmbeddedMessaging?.value}>
      <IterablePlacementContext.Provider value={resolvedPlacementId}>
        {children}
      </IterablePlacementContext.Provider>
    </IterableEmbeddedProvider>
  );
};
